"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.string.small");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.string.small");

require("core-js/modules/es6.array.for-each");

var _driftZoom = _interopRequireDefault(require("drift-zoom"));

var _debounce = _interopRequireDefault(require("lodash-es/debounce"));

var _cssClasses = _interopRequireDefault(require("../helpers/cssClasses"));

var _bind = _interopRequireDefault(require("../mixins/bind"));

var _breakpoints = _interopRequireDefault(require("../helpers/breakpoints"));

var _utils = require("../helpers/utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}
/**
 * DOM selectors.
 */


var selectors = {
  container: '[js-product-gallery="container"]',
  featuredImage: '[js-product-gallery="featuredImage"]',
  thumbnail: '[js-product-gallery="thumbnail"]',
  zoomPane: '[js-product-gallery="zoomPane"]'
};
/**
 * Export a new product gallery.
 */

var _default = function _default() {
  /**
   * Node selectors.
   */
  var nodeSelectors = {
    container: document.querySelectorAll(selectors.container),
    featuredImage: document.querySelectorAll(selectors.featuredImage),
    thumbnail: document.querySelectorAll(selectors.thumbnail),
    zoomPane: document.querySelector(selectors.zoomPane)
  };
  /**
   * Instance globals.
   */

  var featuredImages = {};
  /**
   * Initialise component bind.
   */

  var binder = (0, _bind["default"])(nodeSelectors.container);
  /**
   * Options for Drift zoom.
   */

  var zoomOptions = {
    hoverBoundingBox: true,
    touchBoundingBox: true,
    paneContainer: nodeSelectors.zoomPane,
    touchDelay: 500,
    zoomFactor: 2
  };
  /**
   * Initialise component.
   */

  function init() {
    setThumbnailEvents();
    setDefaultState();
    setEventListeners();
    setResizeEvents();
  }
  /**
   * Set listeners.
   */


  function setThumbnailEvents() {
    _toConsumableArray(nodeSelectors.thumbnail).forEach(function (element) {
      (0, _utils.on)('click', element, function (event) {
        return handleThumbnailClick(event);
      });
    });
  }
  /**
   * Set window resize events for responsive initialisation.
   */


  function setResizeEvents() {
    (0, _utils.on)('resize', (0, _debounce["default"])(handleResizeEvent, 250));
  }
  /**
   * Set default state based on screen size.
   */


  function setDefaultState() {
    if (!window.matchMedia("(min-width: ".concat(_breakpoints["default"].small, ")")).matches) {
      return;
    }

    setZoomEvents();
    binder.set();
  }
  /**
   * Set event listeners.
   */


  function setEventListeners() {
    Frame.EventBus.listen('Variant:change', function (response) {
      return changeProductGallery(response);
    });
  }
  /**
   * Handle resize events through debounce callback.
   * - Disable zoom on small devices.
   */


  function handleResizeEvent() {
    if (!window.matchMedia("(min-width: ".concat(_breakpoints["default"].small, ")")).matches) {
      destroyZoomEvents();
      binder.remove();
      return;
    }

    if (!binder.isSet()) {
      setZoomEvents();
    }

    binder.set();
  }
  /**
   * Set zoom events on featured Images.
   */


  function setZoomEvents() {
    _toConsumableArray(nodeSelectors.featuredImage).forEach(function (element, index) {
      featuredImages[index] = new _driftZoom["default"](element.querySelector('img'), zoomOptions);
    });
  }
  /**
   * Remove zoom events on featured Images.
   */


  function destroyZoomEvents() {
    Object.keys(featuredImages).forEach(function (key) {
      featuredImages[key].destroy();
    });
  }
  /**
   * Handle thumbnail image click.
   * @param {Event} event - Click event on image thumbnail.
   */


  function handleThumbnailClick(event) {
    event.preventDefault();
    updateMainThumbnail(event.currentTarget.dataset.thumbnailId);
  }
  /**
   * Switch main thumbnail image.
   * @param {Number} id - Target thumbnail id to switch to.
   */


  function updateMainThumbnail(id) {
    _toConsumableArray(nodeSelectors.featuredImage).forEach(function (element) {
      if (element.dataset.imageId.includes(id)) {
        element.classList.remove(_cssClasses["default"].hidden);
        return;
      }

      element.classList.add(_cssClasses["default"].hidden);
    });
  }
  /**
   * Change product gallery when the selected variant changed.
   * @param {Object} response - variant object.
   */


  function changeProductGallery(response) {
    if (!response.featured_image) {
      return;
    }

    updateMainThumbnail(response.featured_image.id);
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    init: init
  });
};

exports["default"] = _default;